import { render } from "./SelectTag.vue?vue&type=template&id=1de45249&ts=true"
import script from "./SelectTag.vue?vue&type=script&lang=ts"
export * from "./SelectTag.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__